// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","container":"footer_container__WeoWP","links":"footer_links__7XePM","link":"footer_link__a8fUV"};